// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import callNotificationReducer from './callNotificationSlice';
import callActionsReducer from './callActionsSlice';

const store = configureStore({
  reducer: {
    callNotification: callNotificationReducer,
    callActions: callActionsReducer,
  },
});

export default store;